import { queryOptions } from '@tanstack/react-query'
import { apiClient } from '.'

export const contextsQuery = queryOptions({
  queryKey: ['contexts'],
  queryFn: () => fetchContexts(),
})

async function fetchContexts(): Promise<string[]> {
  return apiClient.get(`/contexts?excludeSelf=true`).then((res) => res.data)
}
